// import { Component, OnInit } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { SysNumberSequence, SysNumberSequenceCounter, SysNumberSequenceService } from '../../../core/services/sys-number-sequence.service';


// @Component({
//       selector: 'app-sys-number-sequence',
//       standalone: true,
//       imports: [CommonModule, FormsModule],
//       templateUrl: './sys-number-sequence.component.html'
// })
// export class SysNumberSequenceComponent implements OnInit {
//       // Shared Dataset Arrays
//       sequences: SysNumberSequence[] = [];
//       counters: SysNumberSequenceCounter[] = [];
//       errorMessage: string = '';

//       // Visual Lightbox Modal Control Matrices
//       showSeqModal: boolean = false;
//       showCounterModal: boolean = false;
//       isEditingSeq: boolean = false;
//       isEditingCounter: boolean = false;

//       // Live Forms Working Buffers
//       currentSeq: SysNumberSequence = this.getResetSeqModel();
//       currentCounter: SysNumberSequenceCounter = this.getResetCounterModel();

//       constructor(private apiService: SysNumberSequenceService) { }

//       ngOnInit(): void {
//             this.refreshDashboard();
//       }

//       refreshDashboard(): void {
//             this.errorMessage = '';

//             // Read Structural Sequences Setup Contexts
//             this.apiService.getAllSequences().subscribe({
//                   next: (res) => this.sequences = res,
//                   error: (err) => this.errorMessage = 'Failed to load number sequences: ' + (err.error?.message || err.message)
//             });

//             // Read Active Live Counter Nodes
//             this.apiService.getAllCounters().subscribe({
//                   next: (res) => this.counters = res,
//                   error: (err) => this.errorMessage = 'Failed to load runtime tracking counters: ' + (err.error?.message || err.message)
//             });
//       }

//       // ---------------------------------------------------------------------
//       // SEQUENCER COMPONENT EVENT RECEPTORS
//       // ---------------------------------------------------------------------
//       openNewSeqModal(): void {
//             this.isEditingSeq = false;
//             this.currentSeq = this.getResetSeqModel();
//             this.showSeqModal = true;
//       }

//       openEditSeqModal(seq: SysNumberSequence): void {
//             this.isEditingSeq = true;
//             this.currentSeq = { ...seq };
//             this.showSeqModal = true;
//       }

//       saveSequence(): void {
//             if (this.isEditingSeq && this.currentSeq.id) {
//                   this.apiService.updateSequence(this.currentSeq.id, this.currentSeq).subscribe({
//                         next: () => { this.showSeqModal = false; this.refreshDashboard(); },
//                         error: (err) => alert(err.error?.message || 'Error mutating configuration parameters.')
//                   });
//             } else {
//                   this.apiService.createSequence(this.currentSeq).subscribe({
//                         next: () => { this.showSeqModal = false; this.refreshDashboard(); },
//                         error: (err) => alert(err.error?.message || 'Error executing initialization registry setup.')
//                   });
//             }
//       }

//       deleteSequence(id: string): void {
//             if (confirm('Erase this system notation configuration mapping index permanently?')) {
//                   this.apiService.deleteSequence(id).subscribe({
//                         next: () => this.refreshDashboard(),
//                         error: (err) => alert(err.error?.message || 'Failed to systemically clean matching nodes.')
//                   });
//             }
//       }

//       // ---------------------------------------------------------------------
//       // COUNTER LAYER EVENT RECEPTORS
//       // ---------------------------------------------------------------------
//       openNewCounterModal(): void {
//             this.isEditingCounter = false;
//             this.currentCounter = this.getResetCounterModel();
//             this.showCounterModal = true;
//       }

//       openEditCounterModal(counter: SysNumberSequenceCounter): void {
//             this.isEditingCounter = true;
//             this.currentCounter = { ...counter };
//             this.showCounterModal = true;
//       }

//       saveCounter(): void {
//             if (this.isEditingCounter && this.currentCounter.id) {
//                   this.apiService.updateCounter(this.currentCounter.id, this.currentCounter).subscribe({
//                         next: () => { this.showCounterModal = false; this.refreshDashboard(); },
//                         error: (err) => alert(err.error?.message || 'Error updating metric values.')
//                   });
//             } else {
//                   this.apiService.createCounter(this.currentCounter).subscribe({
//                         next: () => { this.showCounterModal = false; this.refreshDashboard(); },
//                         error: (err) => alert(err.error?.message || 'Error deploying counter tracking index node.')
//                   });
//             }
//       }

//       deleteCounter(id: string): void {
//             if (confirm('Systematically wipe out this live dynamic metric index track?')) {
//                   this.apiService.deleteCounter(id).subscribe({
//                         next: () => this.refreshDashboard(),
//                         error: (err) => alert(err.error?.message || 'Failed to eliminate target context counter.')
//                   });
//             }
//       }

//       // Resolution utility to map raw foreign sequences IDs into clean readable codes inside UI cells
//       getSequenceCode(sequenceId: string): string {
//             const match = this.sequences.find(s => s.id === sequenceId);
//             return match ? match.code : 'Global Anchor Node';
//       }

//       private getResetSeqModel(): SysNumberSequence {
//             return {
//                   entityName: '', transactionType: '', code: '', name: '', prefix: '', suffix: '',
//                   separator: '/', padding: 5, nextNumber: 1, incrementBy: 1, resetType: 'YEARLY',
//                   financialYear: true, branchWise: false, orgWise: false, isActive: true
//             };
//       }

//       private getResetCounterModel(): SysNumberSequenceCounter {
//             return { sequenceId: '', orgId: '', branchId: '', financialYear: '', currentNumber: 0 };
//       }
// }

import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http'; // 1. Added HttpClient Import
import { SysNumberSequence, SysNumberSequenceCounter, SysNumberSequenceService } from '../../../core/services/sys-number-sequence.service';

interface OrganisationLookup {
      id: string;
      name: string;
}

@Component({
      selector: 'app-sys-number-sequence',
      standalone: true,
      imports: [CommonModule, FormsModule],
      templateUrl: './sys-number-sequence.component.html'
})
export class SysNumberSequenceComponent implements OnInit {
      // Shared Dataset Arrays
      sequences: SysNumberSequence[] = [];
      counters: SysNumberSequenceCounter[] = [];
      organisations: OrganisationLookup[] = []; // 2. Holds list of organisations loaded from endpoint
      errorMessage: string = '';

      // Visual Lightbox Modal Control Matrices
      showSeqModal: boolean = false;
      showCounterModal: boolean = false;
      isEditingSeq: boolean = false;
      isEditingCounter: boolean = false;

      // Live Forms Working Buffers
      currentSeq: SysNumberSequence = this.getResetSeqModel();
      currentCounter: SysNumberSequenceCounter = this.getResetCounterModel();

      // 3. Injected HttpClient alongside your existing service
      constructor(
            private apiService: SysNumberSequenceService,
            private http: HttpClient
      ) { }

      ngOnInit(): void {
            this.refreshDashboard();
      }

      refreshDashboard(): void {
            this.errorMessage = '';

            // Read Structural Sequences Setup Contexts
            this.apiService.getAllSequences().subscribe({
                  next: (res) => this.sequences = res,
                  error: (err) => this.errorMessage = 'Failed to load number sequences: ' + (err.error?.message || err.message)
            });

            // Read Active Live Counter Nodes
            this.apiService.getAllCounters().subscribe({
                  next: (res) => this.counters = res,
                  error: (err) => this.errorMessage = 'Failed to load runtime tracking counters: ' + (err.error?.message || err.message)
            });

            // 4. Fetch the organizations from your permission endpoint directly on load
            this.http.get<OrganisationLookup[]>('https://localhost:7056/api/Permission/organisations').subscribe({
                  next: (res) => this.organisations = res,
                  error: (err) => console.error('Failed to resolve permissions organization lookup records', err)
            });
      }

      // ---------------------------------------------------------------------
      // SEQUENCER COMPONENT EVENT RECEPTORS
      // ---------------------------------------------------------------------
      openNewSeqModal(): void {
            this.isEditingSeq = false;
            this.currentSeq = this.getResetSeqModel();
            this.showSeqModal = true;
      }

      openEditSeqModal(seq: SysNumberSequence): void {
            this.isEditingSeq = true;
            this.currentSeq = { ...seq };
            this.showSeqModal = true;
      }

      saveSequence(): void {
            if (this.isEditingSeq && this.currentSeq.id) {
                  this.apiService.updateSequence(this.currentSeq.id, this.currentSeq).subscribe({
                        next: () => { this.showSeqModal = false; this.refreshDashboard(); },
                        error: (err) => alert(err.error?.message || 'Error mutating configuration parameters.')
                  });
            } else {
                  this.apiService.createSequence(this.currentSeq).subscribe({
                        next: () => { this.showSeqModal = false; this.refreshDashboard(); },
                        error: (err) => alert(err.error?.message || 'Error executing initialization registry setup.')
                  });
            }
      }

      deleteSequence(id: string): void {
            if (confirm('Erase this system notation configuration mapping index permanently?')) {
                  this.apiService.deleteSequence(id).subscribe({
                        next: () => this.refreshDashboard(),
                        error: (err) => alert(err.error?.message || 'Failed to systemically clean matching nodes.')
                  });
            }
      }

      // ---------------------------------------------------------------------
      // COUNTER LAYER EVENT RECEPTORS
      // ---------------------------------------------------------------------
      openNewCounterModal(): void {
            this.isEditingCounter = false;
            this.currentCounter = this.getResetCounterModel();
            this.showCounterModal = true;
      }

      openEditCounterModal(counter: SysNumberSequenceCounter): void {
            this.isEditingCounter = true;
            this.currentCounter = { ...counter };
            // Ensure bound selection variable doesn't fall out of synchronization if database payload value is null/undefined
            if (!this.currentCounter.orgId) {
                  this.currentCounter.orgId = '';
            }
            this.showCounterModal = true;
      }

      saveCounter(): void {
            // Clone form model payload state context to sanitize values safely
            const payload = { ...this.currentCounter };

            // Revert empty dropdown selection values back to null/undefined context for DB layer
            if (payload.orgId === '') {
                  payload.orgId = undefined;
            }

            if (this.isEditingCounter && payload.id) {
                  this.apiService.updateCounter(payload.id, payload).subscribe({
                        next: () => { this.showCounterModal = false; this.refreshDashboard(); },
                        error: (err) => alert(err.error?.message || 'Error updating metric values.')
                  });
            } else {
                  this.apiService.createCounter(payload).subscribe({
                        next: () => { this.showCounterModal = false; this.refreshDashboard(); },
                        error: (err) => alert(err.error?.message || 'Error deploying counter tracking index node.')
                  });
            }
      }

      deleteCounter(id: string): void {
            if (confirm('Systematically wipe out this live dynamic metric index track?')) {
                  this.apiService.deleteCounter(id).subscribe({
                        next: () => this.refreshDashboard(),
                        error: (err) => alert(err.error?.message || 'Failed to eliminate target context counter.')
                  });
            }
      }

      // Resolution utility to map raw foreign sequences IDs into clean readable codes inside UI cells
      getSequenceCode(sequenceId: string): string {
            const match = this.sequences.find(s => s.id === sequenceId);
            return match ? match.code : 'Global Anchor Node';
      }

      private getResetSeqModel(): SysNumberSequence {
            return {
                  entityName: '', transactionType: '', code: '', name: '', prefix: '', suffix: '',
                  separator: '/', padding: 5, nextNumber: 1, incrementBy: 1, resetType: 'YEARLY',
                  financialYear: true, branchWise: false, orgWise: false, isActive: true
            };
      }

      private getResetCounterModel(): SysNumberSequenceCounter {
            return { sequenceId: '', orgId: '', branchId: '', financialYear: '', currentNumber: 0 };
      }
}
